<template>
  <v-date-picker
    v-model="date"
    no-title
    color="primary"
    scrollable
    :allowed-dates="allowedDates"
  >
    <div class="picker-footer">
      <div class="picker-time">
        <v-autocomplete
          v-model="hour"
          :items="hourOptions"
          append-icon=""
          color="primary"
          item-color="primary"
          filled
          class="picker-input picker-hour"
        />
        <v-autocomplete
          v-model="minute"
          :items="minuteOptions"
          append-icon=""
          color="primary"
          item-color="primary"
          filled
          class="picker-input picker-minute"
        />
        <v-autocomplete
          v-model="period"
          :items="['AM', 'PM']"
          append-icon=""
          color="primary"
          item-color="primary"
          filled
          class="picker-input picker-period"
        />
      </div>
      <div class="picker-actions">
        <v-btn
          text
          color="primary"
          class="picker-btn"
          @click="cancel"
        >
          Cancel
        </v-btn>
        <v-btn
          text
          color="primary"
          class="picker-btn"
          @click="ok"
        >
          OK
        </v-btn>
      </div>
    </div>
  </v-date-picker>
</template>

<script>

  const padZero = num => num < 10 ? '0' + num : `${num}`
  const to12Hour = num => num > 12 ? num - 12 : num
  const roundToNearest5 = num => 5 * Math.round(num / 5)

  export default {
    name: 'ValkyrieDatePicker',
    props: {
      initialValue: {
        type: Object,
        default: () => (
          {
            date: null,
            hour: 12,
            minute: 0,
            period: 'AM',
          }
        ),
      },
      allowedDates: {
        type: Function,
        default: d => d,
      },
    },
    data () {
      return {
        date: null,
        hour: '12',
        minute: '00',
        period: 'AM',
      }
    },
    computed: {
      minuteOptions () {
        const options = []
        for (let index = 0; index < 59; index += 5) {
          options.push(padZero(index))
        }
        return options
      },
      hourOptions () {
        return Array.from({ length: 12 }).map((_, i) => `${i + 1}`)
      },
    },
    mounted () {
      this.date = this.initialValue.date
      this.hour = `${to12Hour(this.initialValue.hour)}`
      this.minute = `${roundToNearest5(this.initialValue.minute)}`
      this.period = this.initialValue.period
    },
    methods: {
      cancel () {
        this.$emit('cancel')
      },
      ok () {
        this.$emit('submit-date', {
          date: this.date,
          hour: this.hour,
          minute: this.minute,
          period: this.period,
        })
      },
    },
  }
</script>

<style lang="scss">
.picker-footer {
  width: 100%;
  bottom: 50px;
  .picker-time {
    display: flex;
    justify-content: space-around;
    width: 100%;
    height: 100px;
    margin-bottom: 30px;
    .picker-input {
      display: inline-flex;
      max-width: 65px;
      max-height: 44px;
    }
    .picker-hour::after {
      content: ':';
      position: relative;
      top: 22px;
      left: 10px;
      font-size: 15px;
    }
  }
  .picker-actions {
    padding: 10px;
    display: block;
    width: 298px;
    height: 62px;
    margin: 0;
    background: $na-dark-cream !important;
    position: fixed;
    left: -8px;
    bottom: 0;
    .picker-btn {
      min-width: unset !important;
      width: 47%;
      color: $base;
      margin-left: 7px;
      &:last-of-type {
        color:white  !important;
        background: $primary;
      }
    }
  }
}

</style>
